import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';

import { Granularity, PREV_MONTH, TODAY } from './constants';

type ChartContext = {
  date: { from: number; to: number };
  granularity: Granularity;
  setDate: (date: { from: number; to: number }) => void;
  setGranularity: (granularity: Granularity) => void;
};

const chartContext = createContext<ChartContext | undefined>(undefined);

export const ChartProvider: FC<PropsWithChildren> = ({ children }) => {
  // Initial state
  const [date, setDate] = useState({
    from: PREV_MONTH.toMillis(),
    to: TODAY.toMillis(),
  });
  const [granularity, setGranularity] = useState<Granularity>('day');
  // Memoized state
  const state = useMemo(
    () => ({
      date,
      granularity,
      setDate,
      setGranularity,
    }),
    [date, granularity, setDate, setGranularity]
  );

  return (
    <chartContext.Provider value={state}>{children}</chartContext.Provider>
  );
};

export const useChartContext = () => {
  const state = useContext(chartContext);

  if (!state) {
    throw new Error('useChartContext must be used within <ChartProvider>');
  }

  return state;
};
